module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_9-8f5c52e72692d722c08d5c373876138b.jpg";